import React from 'react';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { Inscription } from '../../../typings/third-party-approved-companies';
import { View } from 'react-native';
import { MyImage } from '../../../components/MyImage';
import MyAppText from '../../../components/MyAppText';
import { translate } from '../../../services/translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCameraCctv, faCloud } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface Props {
    inscription: Inscription;
}

export default function InscriptionCard({ inscription }: Props) {
    const { styles } = useStyles(styleSheet);

    const types = inscription.companyType === 'both' ? ['cloud', 'images'] : [inscription.companyType];

    return (
        <View style={styles.cardsContainer}>
            {types.map(t => (
                <View key={inscription.id + '_' + t} style={styles.card}>
                    <MyImage
                        imageUrl={inscription.files.visualIdentity.fileUrl}
                        style={{
                            width: 240,
                            height: 120,
                            resizeMode: 'contain',
                            borderBottomLeftRadius: 0
                        }}
                    />
                    <View style={styles.body}>
                        <View style={styles.companyTypeContainer}>
                            <MyAppText style={styles.companyTypeTitle(t === 'cloud' ? '#80A6EE' : '#B1A187')}>{translate(t === 'cloud' ? 'cloud' : 'images')}</MyAppText>
                            <View style={styles.companyTypeQuantity}>
                                <MyAppText style={styles.companyTypeTitle(t === 'cloud' ? '#80A6EE' : '#B1A187')}>{t === 'cloud' ? inscription.imageClientCount : inscription.thirdPartyCamerasForImageCount}</MyAppText>
                                <FontAwesomeIcon
                                    icon={t === 'cloud' ? faCloud as IconDefinition : faCameraCctv as IconDefinition}
                                    fontSize={20}
                                    color={t === 'cloud' ? '#80A6EE' : '#B1A187'}
                                />
                            </View>
                        </View>
                        <MyAppText style={styles.companyName}>{inscription.companyName}</MyAppText>
                        <MyAppText style={styles.companyIdentifierNumber}>{inscription.cnpj.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')}</MyAppText>
                    </View>
                </View>
            ))}
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    cardsContainer: {
        flexDirection: 'row',
        gap: 24
    },
    card: {
        borderWidth: 1,
        borderColor: theme.colors.neutral['200'],
        width: 240,
        borderRadius: 8,
        shadowColor: '#000000',
        shadowOpacity: 0.08,
        shadowOffset: {
            height: 4,
            width: -2
        },
        shadowRadius: 4,
        backgroundColor: theme.colors.white['500'],
        overflow: 'hidden'
    },
    body: {
        flexDirection: 'column',
        gap: 16,
        padding: 16
    },
    companyTypeContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    companyTypeTitle: (color: string) => ({
        color: color,
        fontSize: 12,
        fontWeight: '700',
        textTransform: 'uppercase',
    }),
    companyTypeQuantity: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10
    },
    companyName: {
        fontSize: 14,
        fontWeight: '700',
        color: theme.colors.neutral['500'],
    },
    companyIdentifierNumber: {
        fontSize: 14,
        fontWeight: '700',
        color: theme.colors.neutral['400']
    }
}));
